export default {
  moduleTitle: "Organizations",
  // Client accounts see this drawer parent tab as "Company Management"
  // instead -- NavDrawer.tsx swaps to this key at render time for userType
  // "customer", a presentation-only override that never touches the static
  // nav tree.
  moduleTitleClient: "Company Management",
  nav: {
    organization: "Company",
    companies: "Companies",
    admins: "Account Admins",
    regions: "Regions",
    branches: "Branches",
    departments: "Departments",
    individuals: "Individuals",
  },
  actions: {
    view: "View",
    create: "Create",
    update: "Update",
    delete: "Delete",
    restore: "Restore",
  },
  permissions: {
    core: "Core",
    organizationManagement: "Company Management",
    companies: "Companies",
    admins: "Account Admins",
    regions: "Regions",
    branches: "Branches",
    departments: "Departments",
    individuals: "Individuals",
  },
  addCompany: "Add Company",
  editCompany: "Edit Company",
  companyFormSubtitle: "Enter the company details and main information",
  mainInformation: "Main Information",
  attachments: "Attachments",
  listTitle: "Companies",
  listSubtitle: "Manage companies and their account administrators",
  header: {
    description:
      "Follow the status of companies, contracts, and users on one platform, in one place.",
    platformAdmin: "Platform admin",
    accountAdmin: "Account admin",
  },
  tabs: {
    companies: "Companies",
    admins: "Account admins",
  },
  toolbar: {
    add: "Add",
    archive: "Archive",
    search: "Search by company name",
    filters: "Filters",
    clearFilters: "Clear filters",
  },
  stats: {
    title: "Company statistics",
    accounts: "Accounts",
    active: "Active companies",
    inactive: "Inactive companies",
    admins: "Account administrators",
    loading: "Loading",
    error: "Unavailable",
  },
  filters: {
    title: "Company filters",
    type: "Account type",
    allTypes: "All types",
    company: "Company",
    individual: "Individual",
    createdAt: "Created at",
    createdAtPlaceholder: "Select a date range",
    clearDateRange: "Clear date range",
    archivedAt: "Archive date",
    archivedAtPlaceholder: "Select a date range",
  },
  datePicker: {
    nextMonth: "Next month",
    previousMonth: "Previous month",
  },
  table: {
    company: "Company",
    email: "Email",
    admin: "Administrator",
    noAdmin: "No administrator",
    status: "Status",
    createdAt: "Created at",
    archivedAt: "Archive date",
    actions: "Actions",
    empty: "No companies match these filters.",
    error: "Companies could not be loaded.",
    loading: "Loading companies",
    showingCount: "Showing {{count}} of {{total}}",
    rowsPerPageLabel: "Rows per page",
    nextPage: "Next page",
    previousPage: "Previous page",
    pagination: "Pagination",
    sortAscending: "Sort ascending",
    sortDescending: "Sort descending",
  },
  status: {
    active: "Active",
    inactive: "Inactive",
  },
  actionMenu: {
    trigger: "Company actions",
  },
  form: {
    nameEn: "English name",
    nameAr: "Arabic name",
    email: "Email address",
    phoneNumber1: "Primary phone number",
    phoneNumber2: "Secondary phone number",
    countryCode: "Country code",
    countrySaudiArabia: "Saudi Arabia",
    countryEgypt: "Egypt",
    countryUnitedArabEmirates: "United Arab Emirates",
    countryJordan: "Jordan",
    fax: "Fax",
    address: "Address",
    remarks: "Remarks",
    type: "Account type",
    typeCompany: "Company",
    typeIndividual: "Individual",
    currency: "Currency",
    currencyPlaceholder: "Select a currency",
    addAttachments: "Add attachments",
    dropzoneTitle: "Drag files here or click to browse",
    dropzoneHint:
      "PDF, DOC, XLS, PNG, JPG — up to 25 MB per file, 10 files max",
    browseFiles: "Browse files",
    addAnotherAttachment: "Add another attachment",
    removeAttachment: "Remove attachment",
    attachmentComplete: "Complete",
    attachmentPending: "Pending upload",
    fileSizeMb: "{{size}} MB",
    invalidType:
      "Only PDF, DOC, DOCX, XLS, XLSX, PNG and JPG files are allowed.",
    tooLarge: "Each file must not exceed 25 MB.",
    tooMany: "You can upload up to 10 files.",
    cancel: "Cancel",
    loading: "Loading company",
    loadError: "Company could not be loaded.",
    empty: "Company was not found.",
    createSuccessFallback: "Created successfully",
  },
  detail: {
    loading: "Loading company",
    error: "Company could not be loaded.",
    empty: "Company was not found.",
    notAvailable: "Not available",
    accountType: "Account type",
    currency: "Currency",
    admin: "Account administrator",
    title: "Company details",
    backToCompanies: "Back to companies",
    log: "Log",
    companyName: "Company name",
    companyNumber: "Company number",
    noAttachments: "No attachments.",
    deleteTitle: "Delete company",
    deleteDescription: "Delete {{name}}? This cannot be undone.",
    confirmDelete: "Delete company",
    cancelDelete: "Cancel",
    closeDelete: "Close delete dialog",
  },
  deleteDialog: {
    title: "Delete",
    question: "Are you sure you want to delete this company?",
    warning: "This action is permanent and cannot be undone.",
    confirmWord: "DELETE",
    instruction: 'Type "{{word}}" to confirm deletion',
    inputLabel: "Deletion confirmation",
    cancel: "Cancel",
    confirm: "Delete",
    close: "Close delete dialog",
  },
  adminDeleteDialog: {
    title: "Delete",
    question: "Are you sure you want to delete this administrator?",
    warning:
      "The administrator will move to the archive and can be restored later.",
    confirmWord: "DELETE",
    instruction: 'Type "{{word}}" to confirm deletion',
    inputLabel: "Deletion confirmation",
    cancel: "Cancel",
    confirm: "Delete",
    close: "Close delete dialog",
  },
  restoreDialog: {
    title: "Restore Company",
    question: "A company with the same details already exists in the archive",
    prompt: "Do you want to restore this company?",
    cancel: "Cancel",
    confirm: "Restore Company",
    close: "Close restore dialog",
    successFallback: "Company restored successfully.",
  },
  archivedCompanies: {
    title: "Archived Companies",
    subtitle: "Companies that have been archived and can be restored.",
    empty: "No archived companies match these filters.",
  },
  restoreArchivedCompanyDialog: {
    title: "Restore Company",
    question: "Are you sure you want to restore this company?",
    prompt: "The company will become active again and usable in the system.",
    cancel: "Cancel",
    confirm: "Restore Company",
    close: "Close restore dialog",
    successFallback: "Company restored successfully.",
    errorFallback: "The company could not be restored.",
  },
  regions: {
    list: {
      title: "Regions Management",
      subtitle: "Registering and managing company regions",
    },
    toolbar: {
      add: "Add Region",
      archive: "Archive",
      search: "Search regions",
      searchPlaceholder: "Search...",
    },
    table: {
      name: "Region Name",
      empty: "No regions match these filters.",
      error: "Regions could not be loaded.",
      loading: "Loading regions",
      showingCount: "Showing {{count}} of {{total}} regions",
      archivedAt: "Archived at",
    },
    actionMenu: {
      trigger: "Region actions",
    },
    form: {
      addTitle: "Add New Region",
      editTitle: "Edit Region",
      subtitle: "Basic details and information for the file",
      infoSectionTitle: "Region Information",
      nameAr: "Region Name (AR)",
      nameEn: "Region Name (EN)",
      isActive: "Active status",
      isActiveDescription:
        "Inactive regions keep their data but can no longer be assigned to branches.",
      toggleStatusDialog: {
        titleActivate: "Activate Region",
        titleDeactivate: "Deactivate Region",
        questionActivate: "Are you sure you want to activate this region?",
        questionDeactivate: "Are you sure you want to deactivate this region?",
        note: "This change won't be applied until you save.",
        yes: "Yes",
        no: "No",
        close: "Close status change dialog",
      },
      // Offered when the create request matches an archived region.
      restoreDialog: {
        title: "Restore Region",
        question:
          "A region with the same information already exists in the archived regions.",
        prompt: "Would you like to restore this region?",
        cancel: "Cancel",
        confirm: "Restore Region",
        close: "Close restore dialog",
        successFallback: "Region restored successfully.",
        errorFallback: "The region could not be restored.",
      },
      mapSectionTitle: "Define the Region on the Map",
      mapSectionSubtitle:
        "Use the drawing tools to precisely define the region's geographic boundaries.",
      geometryRequired: "Invalid region boundary. Please draw a valid polygon.",
      geometryNotClosed: "Please complete the region boundary before saving.",
      geometrySelfIntersecting:
        "The region boundary cannot intersect itself. Please adjust the polygon.",
      geometryZeroArea: "The region boundary must define a valid area.",
      cancel: "Cancel",
      loading: "Loading region",
      loadError: "The region could not be loaded.",
      createSuccessFallback: "Region added successfully.",
      updateSuccessFallback: "Region updated successfully.",
      back: "Back to regions",
    },
    detail: {
      title: "Region Details",
      loading: "Loading region",
      error: "The region could not be loaded.",
      empty: "Region was not found.",
    },
    map: {
      draw: "Draw Polygon",
      edit: "Edit Polygon",
      delete: "Delete Polygon",
      cutTool: "Delete points",
      drawingHint:
        "Click the map to add points, then click the starting point again to close the shape (at least 3 points).",
      minPointsToast: "A region boundary must contain at least three points.",
    },
    archivedRegions: {
      title: "Archived Regions",
      subtitle: "Regions that have been archived and can be restored.",
      empty: "No archived regions match these filters.",
      back: "Back to regions",
      restore: "Restore region",
      restoreDialog: {
        title: "Restore Region",
        question: "Are you sure you want to restore this region?",
        prompt: "The region will become active again and usable in the system.",
        cancel: "Cancel",
        confirm: "Restore Region",
        close: "Close restore dialog",
        successFallback: "Region restored successfully.",
        errorFallback: "The region could not be restored.",
      },
    },
    archiveDialog: {
      title: "Delete",
      question: "Are you sure you want to delete this region?",
      warning: "The region will move to the archive and can be restored later.",
      confirmWord: "Delete",
      instruction: 'Type "{{word}}" to confirm deletion',
      inputLabel: "Deletion confirmation",
      confirm: "Delete",
      cancel: "Cancel",
      close: "Close delete dialog",
      successFallback: "Region deleted successfully.",
      errorFallback: "The region could not be deleted.",
    },
  },
  branches: {
    list: {
      title: "Branches Management",
      subtitle: "Registering and managing company branches",
    },
    toolbar: {
      add: "Add Branch",
      archive: "Archive",
      search: "Search branches",
      searchPlaceholder: "Search...",
    },
    table: {
      name: "Branch Name",
      empty: "No branches match these filters.",
      error: "Branches could not be loaded.",
      loading: "Loading branches",
      showingCount: "Showing {{count}} of {{total}} branches",
      archivedAt: "Archived at",
    },
    actionMenu: {
      trigger: "Branch actions",
    },
    archiveDialog: {
      title: "Delete",
      question: "Are you sure you want to delete this branch?",
      warning: "The branch will move to the archive and can be restored later.",
      confirmWord: "Delete",
      instruction: 'Type "{{word}}" to confirm deletion',
      inputLabel: "Deletion confirmation",
      confirm: "Delete",
      cancel: "Cancel",
      close: "Close delete dialog",
      successFallback: "Branch deleted successfully.",
      errorFallback: "The branch could not be deleted.",
    },
    form: {
      addTitle: "Add New Branch",
      editTitle: "Edit Branch",
      subtitle: "Basic details and information for the file",
      infoSectionTitle: "Branch Information",
      nameAr: "Branch Name (AR)",
      nameEn: "Branch Name (EN)",
      nameLabel: "Branch Name",
      account: "Account",
      accountPlaceholder: "Select account",
      isActive: "Active status",
      isActiveDescription:
        "Inactive branches keep their data but can no longer be assigned to assets.",
      locationSectionTitle: "Geographic Location",
      country: "Country",
      countryPlaceholder: "Select country",
      governorate: "Governorate",
      governoratePlaceholder: "Select governorate",
      location: "Branch Location",
      locationPlaceholder: "Branch location",
      pickLocation: "Pick location on the map",
      cancel: "Cancel",
      loading: "Loading branch",
      loadError: "The branch could not be loaded.",
      createSuccessFallback: "Branch added successfully.",
      updateSuccessFallback: "Branch updated successfully.",
      saveFailed: "The branch could not be saved.",
      toggleStatusDialog: {
        titleActivate: "Activate Branch",
        titleDeactivate: "Deactivate Branch",
        questionActivate: "Are you sure you want to activate this branch?",
        questionDeactivate: "Are you sure you want to deactivate this branch?",
        note: "This change won't be applied until you save.",
        yes: "Yes",
        no: "No",
        close: "Close status change dialog",
      },
      // Offered when the create request matches an archived branch.
      restoreDialog: {
        title: "Restore Branch",
        question:
          "A branch with the same information already exists in the archived branches.",
        prompt: "Would you like to restore this branch?",
        cancel: "Cancel",
        confirm: "Restore Branch",
        close: "Close restore dialog",
        successFallback: "Branch restored successfully.",
        errorFallback: "The branch could not be restored.",
      },
    },
    map: {
      title: "Branch Location",
      confirm: "Confirm location",
      close: "Close",
    },
    detail: {
      title: "Branch Details",
      locationSectionTitle: "Geographic Location",
      notAvailable: "Not available",
      loading: "Loading branch",
      error: "The branch could not be loaded.",
      empty: "Branch was not found.",
      backToBranches: "Back to branches",
    },
    archivedBranches: {
      title: "Archived Branches",
      subtitle: "Branches that have been archived and can be restored.",
      empty: "No archived branches match these filters.",
    },
    restoreDialog: {
      title: "Restore Branch",
      question: "Are you sure you want to restore this branch?",
      prompt: "The branch will become active again and usable in the system.",
      cancel: "Cancel",
      confirm: "Restore Branch",
      close: "Close restore dialog",
      successFallback: "Branch restored successfully.",
      errorFallback: "The branch could not be restored.",
    },
  },
  departments: {
    title: "Departments Management",
    registered: "Registering and managing company departments",
    search: "Search...",
    toolbar: {
      add: "Add department",
      archive: "Archive",
    },
    create: {
      breadcrumb: "Add department",
      title: "Add New Department",
      subtitle: "Enter the new department's details",
      back: "Back to departments",
      mainSection: "Department information",
      additionalSection: "Additional information",
      nameAr: "Department name",
      nameEn: "Department name",
      arabicTag: "(AR)",
      englishTag: "(EN)",
      remarks: "Remarks",
      optional: "(Optional)",
      remarksPlaceholder: "Remarks",
      save: "Save",
      cancel: "Cancel",
      successFallback: "Department created successfully.",
      duplicate: "Department already exists",
      failure: "Unable to create the Department. Please try again.",
      // Offered when the create request matches an archived department.
      restoreDialog: {
        title: "Restore Department",
        question:
          "A department with the same information already exists in the archived departments.",
        prompt: "Would you like to restore this department?",
        cancel: "Cancel",
        confirm: "Restore Department",
        close: "Close restore dialog",
      },
    },
    unsavedChanges: {
      title: "Unsaved changes",
      message: "You have unsaved changes. Are you sure you want to leave?",
      stay: "Stay",
      leave: "Leave",
      close: "Close dialog",
    },
    actions: {
      trigger: "Department actions",
      view: "View details",
      edit: "Edit",
      delete: "Delete",
    },
    detail: {
      back: "Back to departments",
      subtitle: "The department's details and basic information",
      section: "Department details",
      branch: "Branch name",
      status: "Active status",
      active: "Active",
      inactive: "Inactive",
      remarks: "Remarks",
      notAvailable: "Not available",
      edit: "Edit",
      loading: "Loading department",
      error: "The department could not be loaded.",
    },
    edit: {
      back: "Back to departments",
      save: "Save changes",
      status: "Active status",
      statusActive: "Department is active",
      statusInactive: "Department is inactive",
      success: "Department updated successfully.",
      failure: "Unable to update the Department. Please try again.",
    },
    statusDialog: {
      title: "Change status",
      message: "Are you sure you want to change department status?",
      note: "This change won't be applied until you save.",
      yes: "Yes",
      no: "No",
    },
    deleteDialog: {
      title: "Delete",
      question: "Are you sure you want to delete this department?",
      warning:
        "The department will move to the archive and can be restored later.",
      confirmWord: "Delete",
      instruction: 'Type "{{word}}" to confirm deletion',
      inputLabel: "Deletion confirmation",
      cancel: "Cancel",
      confirm: "Delete",
      close: "Close delete dialog",
      success: "Department deleted and moved to the archive.",
    },
    archived: {
      back: "Back to departments",
      title: "Archived Departments",
      subtitle: "Departments that have been archived and can be restored.",
      archivedAt: "Archive date",
      empty: "No archived departments match this search.",
      restore: "Restore",
    },
    restoreDialog: {
      title: "Restore Department",
      question: "Are you sure you want to restore this department?",
      prompt:
        "The department will become active again and usable in the system.",
      cancel: "Cancel",
      confirm: "Restore Department",
      close: "Close restore dialog",
      successFallback: "Department restored successfully.",
      errorFallback: "The department could not be restored.",
    },
    table: {
      name: "Department name",
      empty: "No departments match this search.",
      error: "Departments could not be loaded.",
      loading: "Loading departments",
    },
  },
};
